import { useLocation } from '@reach/router';
import { initializeAndTrack } from 'gatsby-plugin-gdpr-cookies';
import React, { useState } from 'react';
import Link from '../atoms/Link';

const CookiePopup = () => {
  const [show, setShow] = useState(
    typeof document === 'undefined' ||
      document.cookie.indexOf('gatsby-gdpr-google-analytics=true') === -1,
  );
  const location = useLocation();

  const accept = () => {
    document.cookie = 'gatsby-gdpr-google-analytics=true; path=/';
    setShow(false);
    initializeAndTrack(location);
  };

  if (!show) {
    return null;
  }

  return (
    <div className="z-[9999] bg-white border border-slate-50 fixed left-8 bottom-8 right-8 px-5 py-3 shadow rounded flex flex-col sm:flex-row sm:items-center sm:justify-between space-y-4 sm:space-y-0 sm:space-x-4">
      <p className="text-xs text-slate-600">
        We use our own and third-party cookies to improve your experience and
        our services, and to analyse the use of our website. By clicking Accept
        we take that to mean that you accept our{' '}
        <Link href="/privacy" className="text-primary">
          privacy policy
        </Link>
        .
      </p>
      <button
        type="button"
        className="px-4 py-2 text-xs font-semibold text-white transition rounded bg-primary hover:opacity-80 u-ring"
        onClick={accept}
      >
        Accept
      </button>
    </div>
  );
};

export default CookiePopup;
